import { render } from "./Photographer.vue?vue&type=template&id=1c583dfa&scoped=true"
import script from "./Photographer.vue?vue&type=script&lang=js"
export * from "./Photographer.vue?vue&type=script&lang=js"

import "./Photographer.vue?vue&type=style&index=0&id=1c583dfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c583dfa"]])

export default __exports__